module.exports = __webpack_public_path__ + "img/Mail.abb7a1b9.svg";